var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.addressRecord.legal_type === 'person')?_c('KpIcon',{attrs:{"icon-cls":"person","size":_vm.size,"color":"grey","title":_vm.$t('person')}}):(_vm.addressRecord.legal_type === 'organization')?_c('KpIcon',{attrs:{"icon-cls":"institution","color":"grey","size":_vm.size,"title":_vm.$t('organization')}}):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }